import React from "react";

import AccountView from "../modules/Account";

export default function Account() {
  return <AccountView />;
}
